import { initialState } from "./State";
import { AdditionalInformation } from "us.collection.debtor/constants/Actions";

const {
  GET_ADDITIONAL_INFORMATION,
  GET_ADDITIONAL_INFORMATION_SUCCESS,
  GET_ADDITIONAL_INFORMATION_FAIL,

  HANDLE_ADDITIONAL_INFORMATION_DRAWER,
  RESET_ADDITIONAL_INFORMATION_DATA,

  NEW_ADDITIONAL_INFORMATION,
  NEW_ADDITIONAL_INFORMATION_SUCCESS,
  NEW_ADDITIONAL_INFORMATION_FAIL,

  UPDATE_ADDITIONAL_INFORMATION,
  UPDATE_ADDITIONAL_INFORMATION_SUCCESS,
  UPDATE_ADDITIONAL_INFORMATION_FAIL,

  GET_INFORMATION_META_DATA,
  GET_INFORMATION_META_DATA_SUCCESS,
  GET_INFORMATION_META_DATA_FAIL,

  GET_DATA_TYPE_VALUES,
  GET_DATA_TYPE_VALUES_SUCCESS,
  GET_DATA_TYPE_VALUES_FAIL,
} = AdditionalInformation;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_ADDITIONAL_INFORMATION:
      return Object.assign({}, state, {
        informationList: {
          data: [],
          isLoading: true,
        },
      });
    case GET_ADDITIONAL_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        informationList: {
          isLoading: false,
          data: payload.data,
        },
      });
    case GET_ADDITIONAL_INFORMATION_FAIL:
      return Object.assign({}, state, {
        informationList: {
          data: [],
          isLoading: true,
        },
      });

    case HANDLE_ADDITIONAL_INFORMATION_DRAWER:
      return Object.assign({}, state, {
        drawerInfo: {
          ...state.drawerInfo,
          ...payload.data,
          visible: !state.drawerInfo.visible,
        },
      });

    case NEW_ADDITIONAL_INFORMATION:
      return Object.assign({}, state, {
        isInformationSaving: true,
      });
    case NEW_ADDITIONAL_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        isInformationSaving: false,
      });
    case NEW_ADDITIONAL_INFORMATION_FAIL:
      return Object.assign({}, state, {
        isInformationSaving: false,
      });

    case UPDATE_ADDITIONAL_INFORMATION:
      return Object.assign({}, state, {
        isInformationSaving: true,
      });
    case UPDATE_ADDITIONAL_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        isInformationSaving: false,
      });
    case UPDATE_ADDITIONAL_INFORMATION_FAIL:
      return Object.assign({}, state, {
        isInformationSaving: false,
      });
    case RESET_ADDITIONAL_INFORMATION_DATA:
      return Object.assign({}, state, {
        ...initialState,
      });
    case GET_INFORMATION_META_DATA:
      return Object.assign({}, state, {
        infoMetaData: {
          statusOptions: [],
          infoOptions: [],
          isLoading: true,
        },
      });
    case GET_INFORMATION_META_DATA_SUCCESS:
      const { statusOptions, infoOptions } = payload.data ?? {};
      return Object.assign({}, state, {
        infoMetaData: {
          statusOptions,
          infoOptions,
          isLoading: false,
        },
      });
    case GET_INFORMATION_META_DATA_FAIL:
      return Object.assign({}, state, {
        infoMetaData: {
          statusOptions: [],
          infoOptions: [],
          isLoading: false,
        },
      });
    case GET_DATA_TYPE_VALUES:
      return Object.assign({}, state, {
        bmdDataTypeValues: {
          ...state.bmdDataTypeValues,
          [payload.data.dataTypeId]: {
            data: [],
            isLoading: true,
          },
        },
      });
    case GET_DATA_TYPE_VALUES_SUCCESS:
      return Object.assign({}, state, {
        bmdDataTypeValues: {
          ...state.bmdDataTypeValues,
          [payload.data.dataTypeId]: {
            data: payload.data.values,
            isLoading: false,
          },
        },
      });
    case GET_DATA_TYPE_VALUES_FAIL:
      return Object.assign({}, state, {
        bmdDataTypeValues: {
          ...state.bmdDataTypeValues,
          [payload.data.dataTypeId]: {
            data: [],
            isLoading: false,
          },
        },
      });
    default:
      return state;
  }
};
